
import Subtitle from '@/components/elements/Subtitle.vue'
import { teaserImageUrl } from '@/helpers/ImageUrls'
import { citypassIsEnabled, eventIsInCart } from '@/state/Miscellaneous'
import store from '@/store/store'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'EventListingItem',
  components: { Subtitle },
})
export default class extends Vue {
  @Prop()
  event: EventWithMeta

  @Prop()
  path: string

  get imageUrl() {
    return teaserImageUrl(this.event)
  }

  get imageAltText() {
    return this.event.meta.image_alt_text ?? `Image for ${this.event.name}`
  }

  get classes() {
    return {
      'in-cart': eventIsInCart(this.event),
      citypass: this.showCitypassIcon,
    }
  }

  private get showCitypassIcon(): boolean {
    if (store.getters['Cart/cartHasItems'] && !this.$store.state.Cart.hasCitypassCoupons) {
      // Don't show CityPASS icon on upsells for non-CityPASS carts.
      return false
    } else {
      return citypassIsEnabled(this.event)
    }
  }

  get linkTitle() {
    return this.$t('linkTitle', { name: this.event.name })
  }
}
